import { IPhone } from '../../../store/similar';

export const isCorrectPhoneObject = (phone?: IPhone | null): boolean => {
  return !!(phone && phone.countryCode && phone.number);
};
